<template>
  <!-- 工单详情弹框 -->
  <el-dialog
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
  >
    <span slot="title" style="font-weight: 700;">{{ num + "#" }}机台预警</span>
    <el-form inline class="demo-table-expand">
      <el-form-item label="转速偏离预警" label-width="auto">
        <span>{{ orderData.speedThreshold + "%" }}</span>
      </el-form-item>
      <el-form-item v-show="this.kind==0" label="送经量偏离预警" label-width="auto">
        <span>{{ orderData.feedThreshold + "%" }}</span>
      </el-form-item>
      <el-form-item v-show="this.kind==0" label="盘头剩余时长预警" label-width="auto">
        <span>{{ orderData.leftTimeThreshold + "小时" }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-radio v-model="radio1" label="1" border>全部机台</el-radio>
        <el-radio v-model="radio1" label="2" border>当前机台</el-radio>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save()">保存</el-button></el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from "@/api/factory/dashboard";
export default {
  data() {
    return {
      dialogVisible: false,
      orderData: [],
      num: "",
      id:'',
      kind:'',
      radio1: '2',
    };
  },
  methods: {
    // 外部调用，展示工单详情弹框
    show(id, num,kind) {
      this.num = num;
      this.id=id
      this.kind=kind
      //type 0 为用工单ID查询 1为用机台ID查询
      // TODO 这里可能要改成枚举
      this.dialogVisible = true;
      this.getWorkOrderByMachineId(id);
    },
    // 根据机台ID获取工单信息
    getWorkOrderByMachineId(machineId) {
      console.log(111);
      return api.getWarn({ machineIds: [machineId] }).then((res) => {
        console.log(res);
        this.orderData = this.formatResponse(res.data[0]);
      });
    },
    // 格式化工单信息
    formatResponse(res) {
      res.speedThreshold = res.speedThreshold;
      res.feedThreshold = res.feedThreshold;
      res.leftTimeThreshold = res.leftTimeThreshold;
      return res;
    },
    save(){
      this.dialogVisible = false
      return api.getUpdateThreshold({
        id:this.id,
        number:this.num,
        speedThreshold:this.orderData.speedThreshold,
        feedThreshold:this.orderData.feedThreshold,
        leftTimeThreshold:this.orderData.leftTimeThreshold,
      }).then(res=>{
        console.log(res);
        if(res.code==200){
          this.$message({
          message: '保存成功',
          type: 'success'
        })
        }
        
      })
    }
  },
  mounted() {},
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
  display: grid;
  grid-template-columns: 50% 50%;
}
.demo-table-expand label {
  width: 100px;
  color: #99a9bf;
  text-align: left;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}
</style>
